/* Saabhi — global helpers (menu drawer is handled in header.liquid). */
(function () {
  // Track header height so marquee can stick exactly below it on every page.
  function setHeaderHeight() {
    var h = document.querySelector('.site-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener('load', setHeaderHeight);
  // Re-measure when fonts swap in (changes header height slightly)
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderHeight);

  // Reveal on scroll — auto-tag every Shopify section + opt-in [data-reveal] elements
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
}, { threshold: 0, rootMargin: '0px' });

    // Auto-mark sections so the whole site has smooth section entrance animations
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      // Skip header/footer/marquee/article — long pages should NOT hide-then-reveal
      if (/header|footer|marquee|article/.test(el.id)) return;
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });

    // Stagger groups
    document.querySelectorAll('.ps__scroller, .grid--4, .grid--3, .bot__badges, .exsp__grid, .shg__grid, .rxr__scroller, .pscard__perks')
      .forEach(function (el) {
        el.setAttribute('data-reveal-stagger', '');
        io.observe(el);
      });

    // Explicit opt-ins
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
})();
